import { Box, Flex } from '@chakra-ui/react';

interface SegmentedItem {
  value: string;
  label: string;
}
interface SegmentedProps {
  items: SegmentedItem[];
  value: string;
  onChange: (value: string) => void;
}

/** DS segmented control (design-guidelines.md §4). */
export const Segmented = ({ items, value, onChange }: SegmentedProps) => (
  <Flex
    gap='3px'
    display='inline-flex'
    p='3px'
    bg='bg.canvas'
    borderWidth='1px'
    borderColor='border.default'
    borderRadius='md'
  >
    {items.map((item) => {
      const active = item.value === value;
      return (
        <Box
          key={item.value}
          as='button'
          px={3}
          py={2}
          color={active ? 'text.default' : 'text.muted'}
          fontSize='sm'
          fontWeight={500}
          bg={active ? 'bg.surface' : 'transparent'}
          borderRadius='sm'
          shadow={active ? 'ds_xs' : 'none'}
          transition='background 0.16s ease-out, color 0.16s ease-out'
          onClick={() => onChange(item.value)}
        >
          {item.label}
        </Box>
      );
    })}
  </Flex>
);

export default Segmented;
